import React from "react";
import { EMPTY_STRING } from "../../../../constants";

const Sidebar = ({
  features,
  selected,
  changeSelectedFeature,
  erroredFeatures,
}) => {
  return (
    <div className="sidebar">
      <div className="modal-heading">Features and Amenities</div>
      <div>
        <ul>
          {features.map((feature) => (
            <li
              key={feature.id}
              className={`feature ${
                feature.id === selected
                  ? "selected-feature"
                  : erroredFeatures.includes(feature.id)
                  ? "text-danger"
                  : EMPTY_STRING
              }`}
              onClick={() => changeSelectedFeature(feature.id)}
            >
              {feature.title}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;
